"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const offsetStyles = {
    outlineWidth: 2,
    outlineOffset: '-2px'
};
const BaseInput = styled_1.default.input({
    'alignContent': 'center',
    'borderRadius': 6,
    'padding': '15px 18px',
    'width': '100%',
    'border': 'none',
    'outlineStyle': 'solid',
    'outlineWidth': '1px',
    '&:hover, &:disabled': {
        cursor: 'default'
    },
    'outlineOffset': '-1px',
    '&:focus, &:focus-visible, &:focus-within': {
        ...offsetStyles
    }
}, ({ theme, variant, leftIcon }) => ({
    'backgroundColor': theme.palette.colors.lotion,
    'outlineColor': theme.palette.colors.lightPeriwinkle,
    'color': theme.palette.colors.blackCoral,
    'fontWeight': theme.typography.fontWeightLight,
    ...(variant && {
        ...offsetStyles
    }),
    ...(variant === 'success' && {
        outlineColor: theme.palette.success
    }),
    ...(variant === 'error' && {
        outlineColor: theme.palette.error
    }),
    ...(!!leftIcon && {
        paddingLeft: '50px'
    }),
    '&::placeholder': {
        color: theme.palette.colors.coolGrey
    },
    '&:hover, &:disabled': {
        backgroundColor: theme.palette.colors.antiFlash
    },
    '&:focus, &:focus-visible, &:focus-within': {
        'outlineColor': theme.palette.colors.dodgerBlue,
        '&::placeholder': {
            color: theme.palette.text.disabled
        }
    },
    '&:disabled': {
        outlineColor: theme.palette.text.disabled
    }
}));
exports.default = BaseInput;
//# sourceMappingURL=BaseInput.js.map